export const PAGE_CONTENT = {
  it: {
    services: {
      kicker: "Per i proprietari",
      heroTitle: "Trasformiamo la tua casa in una rendita stabile.",
      heroItalic: "Senza stress. Senza improvvisazioni.",
      heroSub: "Gestione premium con presenza locale reale in Ogliastra. Più prenotazioni, meno problemi, controllo totale.",
      heroCta: "Richiedi la valutazione gratuita",
      heroBadges: ["Analisi reale del potenziale", "Nessun impegno", "Risposta entro 24 ore"],
      problems: {
        title: "Ti riconosci in uno di questi problemi?",
        items: [
          "Poco tempo per gestire tutto",
          "Prezzi sbagliati = soldi persi",
          "Paura di ospiti problematici o recensioni negative",
          "Nessun controllo reale sulla gestione",
        ],
        note: "Se ti riconosci anche solo in uno di questi punti, sei nel posto giusto.",
        strong: "Non devi fare tutto da solo.",
      },
      about: {
        kicker: "Il tuo partner locale in Ogliastra",
        title: "Gestione professionale, tocco umano",
        p1: "OGStay è un team locale che vive l'Ogliastra ogni giorno e tratta ogni proprietà come se fosse propria. Non siamo una piattaforma automatica: siamo persone reali sul territorio.",
        p2: "Seguiamo un numero limitato di proprietà per garantire qualità, controllo e attenzione ai dettagli. Con oltre 9 anni di esperienza negli affitti brevi in Sardegna, uniamo conoscenza del mercato locale, strategie di marketing testate e assistenza continua.",
        p3: "Il risultato? Proprietari sereni, ospiti soddisfatti e rendite ottimizzate.",
        stat: "9+",
        statLabel: "Anni di esperienza negli affitti brevi",
      },
      why: {
        kicker: "Perché scegliere OGStay",
        title: "Non gestiamo case. Proteggiamo investimenti.",
        sub: "OGStay è la scelta di chi vuole risultati concreti, controllo totale e zero stress.",
        items: [
          { title: "Presenza locale reale", text: "Siamo fisicamente in Ogliastra. Interveniamo subito, conosciamo il territorio e seguiamo ogni proprietà da vicino." },
          { title: "Rendita ottimizzata", text: "Pricing dinamico e strategie testate per aumentare occupazione e guadagni, basate su dati reali." },
          { title: "Gestione completa 24/7", text: "Ospiti, emergenze, pulizie e coordinamento: ci occupiamo di tutto, sempre." },
          { title: "Trasparenza totale", text: "Accesso chiaro a prenotazioni, entrate e report. Nessuna sorpresa." },
          { title: "Approccio umano e selettivo", text: "Seguiamo poche proprietà alla volta. Preferiamo qualità a quantità. La tua casa viene trattata come fosse nostra." },
        ],
      },
      tiers: {
        kicker: "Livelli di gestione",
        title: "Scegli il livello di supporto che fa per te",
        sub: "Ogni soluzione è pensata per massimizzare i tuoi ricavi e ridurre lo stress.",
        items: [
          {
            name: "Gestione Light",
            tagline: "Ottimizzazione professionale online",
            desc: "Gestisci tu l'operatività. Noi ottimizziamo le performance.",
            long: "Per proprietari autonomi e strutturati che vogliono mantenere il controllo operativo con una gestione digitale impeccabile, multipiattaforma e orientata ai numeri.",
            price: "10% – 15%",
            priceNote: "in base alle tue esigenze",
            features: [
              "Restauro completo dell'annuncio (testi, struttura, immagini)",
              "Ottimizzazione multipiattaforma (Airbnb, Booking e canali principali)",
              "Strategia di pricing dinamico basata su dati reali",
              "Supporto comunicazione ospiti con template professionali",
              "Consulenza operativa continuativa",
              "Analisi performance periodica con suggerimenti",
              "Affiancamento strategico per rendimento e visibilità",
            ],
            cta: "Richiedi informazioni",
          },
          {
            name: "Gestione Totale",
            badge: "Servizio principale",
            tagline: "Soluzione chiavi in mano",
            desc: "Ci occupiamo di tutto. Tu incassi.",
            long: "La soluzione completa per chi vuole risultati concreti senza occuparsi dell'operatività quotidiana: dalla visibilità online alla gestione degli ospiti, fino al controllo delle performance.",
            price: "20% – 25%",
            priceNote: "in base a immobile, zona e stagionalità",
            features: [
              "Gestione annunci Airbnb / Booking e principali portali",
              "Strategia di pricing dinamico basata su dati reali",
              "Comunicazione ospiti 24/7",
              "Check-in / Check-out professionali",
              "Coordinamento pulizie e biancheria",
              "Gestione imprevisti e manutenzione ordinaria",
              "Shooting fotografico iniziale",
              "Supporto burocratico di avviamento",
              "Report mensili e controllo completo delle performance",
            ],
            cta: "Richiedi la valutazione gratuita",
          },
          {
            name: "Gestione Su Misura",
            tagline: "Costruita sul tuo caso",
            desc: "Per immobili con caratteristiche specifiche o proprietari che desiderano un servizio costruito su misura.",
            long: "Analizziamo il tuo caso e creiamo una soluzione personalizzata, modulare e flessibile.",
            price: "Da valutare",
            priceNote: "in base alle tue esigenze",
            features: [
              "Consulenza strategica dedicata",
              "Moduli attivabili su richiesta",
              "Flessibilità operativa",
              "Supporto personalizzato",
            ],
            cta: "Parliamone insieme",
          },
        ],
      },
      portalAccess: {
        kicker: "Sei già cliente OGStay?",
        title: "Il tuo portale proprietari",
        sub: "Prenotazioni, calendario, rendite e report della tua proprietà: tutto sotto controllo, in un unico posto.",
        cta: "Accedi al portale proprietari",
      },
      premium: {
        kicker: "Servizi premium aggiuntivi",
        title: "Valorizza al massimo la tua proprietà",
        cta: "Richiedi una consulenza",
        items: [
          { title: "Shooting fotografico professionale", price: "Da valutare", text: "Foto di alta qualità che aumentano le prenotazioni e valorizzano ogni dettaglio della tua proprietà." },
          { title: "Restauro annuncio", price: "Da 250€", text: "Ottimizzazione completa del tuo annuncio per massimizzare le conversioni e la visibilità." },
          { title: "Avviamento burocratico", price: "Da 300€", text: "Gestione completa di autorizzazioni, registrazioni e documentazione necessaria." },
          { title: "Consulenza strategica 1:1", price: "150€/ora", text: "Sessione personalizzata per ottimizzare la tua strategia di gestione e pricing." },
        ],
      },
      valuation: {
        kicker: "Valutazione gratuita",
        title: "Scopri quanto può rendere la tua proprietà",
        sub: "Compila il form e ricevi una valutazione gratuita e senza impegno. Ti diremo quanto può fruttare il tuo immobile in Ogliastra con una gestione professionale.",
        perks: [
          { title: "100% gratuito", text: "Nessun costo nascosto, nessun impegno." },
          { title: "Risposta in 24 ore", text: "Analisi rapida e professionale del potenziale." },
          { title: "Esperti del territorio", text: "Conosciamo l'Ogliastra come nessun altro." },
        ],
        form: {
          name: "Nome e cognome",
          namePh: "Maria Piras",
          email: "Email",
          emailPh: "maria@email.it",
          phone: "Telefono / WhatsApp",
          phonePh: "+39 333 000 0000",
          role: "Chi sei?",
          roles: ["Proprietario", "Property manager", "Investitore", "Altro"],
          type: "Tipo di immobile",
          types: ["Appartamento", "Casa indipendente", "Villa", "B&B / Affittacamere", "Residence", "Altro"],
          location: "Dove si trova?",
          locationPh: "Tortolì, Arbatax, Baunei…",
          units: "Quante unità?",
          unitsOpts: ["1", "2–3", "4–10", "10+"],
          guests: "Quanti ospiti può ospitare?",
          guestsOpts: ["2", "4", "6", "8", "10+"],
          status: "Stato attuale",
          statusOpts: [
            "Già attiva su Airbnb, Booking, ecc.",
            "Attiva ma rende poco",
            "Non ancora attiva",
            "In ristrutturazione",
          ],
          platforms: "Piattaforme che usi (se già attiva)",
          platformsOpts: ["Airbnb", "Booking.com", "Vrbo", "Expedia", "Altro"],
          submit: "Richiedi valutazione gratuita",
          sending: "Invio in corso…",
          success: "Richiesta inviata. Ti risponderemo entro 24 ore con un'analisi dettagliata.",
          error: "Qualcosa non ha funzionato. Riprova tra poco.",
          note: "Nessun costo, nessun impegno.",
        },
      },
      guida: {
        kicker: "Guida ospiti personalizzata",
        value: "Valore 34,90€ · Gratuita per un periodo limitato",
        title: "La guida che migliora l'esperienza degli ospiti",
        sub: "Uno strumento premium che aumenta le recensioni positive e riduce le richieste degli ospiti.",
        points: [
          "Modello professionale pronto all'uso",
          "Personalizzabile per ogni proprietà",
          "Aumenta le recensioni positive",
          "Riduce le richieste degli ospiti",
          "Scaricata da oltre 200 proprietari",
        ],
        form: {
          name: "Nome",
          namePh: "Maria",
          email: "Email",
          emailPh: "maria@email.it",
          submit: "Ricevi la guida gratuita",
          sending: "Invio in corso…",
          success: "Richiesta ricevuta: ti invieremo la guida via email.",
          error: "Qualcosa non ha funzionato. Riprova tra poco.",
          note: "Richiedendo la guida accetti di essere contattato da OGStay per una consulenza gratuita.",
        },
      },
      steps: {
        kicker: "Come iniziare",
        title: "Tre semplici passi per trasformare la tua proprietà",
        items: [
          { title: "Contatto", text: "Parliamo della tua proprietà e delle tue esigenze. Nessun impegno." },
          { title: "Valutazione", text: "Analizziamo il potenziale della tua casa. Numeri reali, nessuna promessa vuota." },
          { title: "Decisione", text: "Ricevi la proposta personalizzata. Poi decidi tu, senza pressioni." },
        ],
      },
      final: {
        title: "Nessun impegno. Numeri reali. Poi decidi tu.",
        sub: "Richiedi una valutazione gratuita della tua proprietà e scopri quanto potresti guadagnare con una gestione professionale.",
        ctaPrimary: "Richiedi la valutazione gratuita",
        ctaSecondary: "Vedi le nostre proprietà",
      },
    },
    experiences: {
      kicker: "Esperienze",
      heroTitle: "Le esperienze di OGStay",
      heroSub: "La Sardegna autentica, selezionata con cura. Ogni esperienza è stata scelta personalmente dal nostro team per garantire qualità, autenticità e un contatto genuino con il territorio.",
      badge: "Selezionata da OGStay",
      from: "A partire da",
      person: "a persona",
      priceNote: "Prezzo finale da concordare",
      cta: "Richiedi informazioni",
      items: [
        {
          title: "Escursione in barca nel Golfo di Orosei",
          text: "Scopri le acque cristalline e le spiagge incontaminate del Golfo di Orosei con un tour guidato in barca.",
          location: "Porto di Arbatax",
          duration: "Giornata intera (8 ore)",
          schedule: "Tutti i giorni, da maggio a ottobre",
          price: "€95",
        },
        {
          title: "Degustazione vini in cantina",
          text: "Un viaggio sensoriale tra i sapori autentici della Sardegna con una degustazione guidata di vini locali.",
          location: "Cantina locale, Loceri",
          duration: "2,5 ore",
          schedule: "Martedì, giovedì e sabato, su prenotazione",
          price: "€45",
        },
        {
          title: "Trekking nel Parco del Gennargentu",
          text: "Esplora la natura selvaggia e i panorami mozzafiato del Gennargentu con una guida esperta del territorio.",
          location: "Base del Parco, Fonni",
          duration: "Mezza giornata (5 ore)",
          schedule: "Mercoledì e domenica, su richiesta",
          price: "€60",
        },
      ],
      why: {
        title: "Perché scegliere OGStay",
        sub: "Ogni esperienza è selezionata con cura dal nostro team locale per garantire qualità, autenticità e un contatto genuino con la Sardegna.",
        items: [
          { title: "Curazione locale", text: "Selezionate personalmente dal nostro team, che conosce ogni angolo della Sardegna." },
          { title: "Guide autentiche", text: "Esperti locali che condividono la vera essenza del territorio con passione." },
          { title: "Qualità garantita", text: "Ogni esperienza è testata e approvata per garantire il massimo valore." },
          { title: "Affidabilità", text: "Partner verificati e relazioni consolidate per un'esperienza senza preoccupazioni." },
        ],
      },
      note: "OGStay non è un'agenzia turistica né un tour operator. Siamo curatori locali che selezionano e consigliano le migliori esperienze della Sardegna: prenotazioni e pagamenti avvengono direttamente con i fornitori delle esperienze.",
    },
    guide: {
      kicker: "Guide e consigli",
      title: "Il journal di OGStay",
      sub: "Storie, segreti e consigli da chi vive l'Ogliastra ogni giorno. Scopri il territorio con occhi nuovi.",
      featured: "In evidenza",
      readMore: "Leggi l'articolo",
      newsletter: {
        title: "Rimani aggiornato",
        sub: "Iscriviti alla newsletter per ricevere consigli, guide e offerte esclusive direttamente nella tua inbox.",
        emailPh: "La tua email",
        submit: "Iscriviti",
        sending: "Invio…",
        success: "Iscrizione confermata. Benvenuto nel journal di OGStay.",
        error: "Qualcosa non ha funzionato. Riprova tra poco.",
      },
    },
    article: {
      back: "Torna alle guide",
      related: "Leggi anche",
      ctaTitle: "Vivi l'Ogliastra con OGStay",
      ctaSub: "Case selezionate, esperienze autentiche e un team locale sempre disponibile.",
      cta: "Scopri le case",
    },
    chat: {
      title: "Concierge OGStay",
      sub: "Sempre al tuo fianco",
      welcome: "Ciao! Sono il concierge di OGStay. Chiedimi pure di case, esperienze, disponibilità o consigli sull'Ogliastra.",
      placeholder: "Scrivi un messaggio…",
      send: "Invia",
      open: "Apri il concierge",
      close: "Chiudi il concierge",
      error: "Ops, qualcosa non ha funzionato. Riprova tra poco.",
      suggestions: ["Quali case avete in Ogliastra?", "Quanto costa l'escursione in barca?", "Come funziona la prenotazione diretta?"],
    },
    staysSearch: {
      label: "La tua ricerca",
      where: "Destinazione",
      checkin: "Arrivo",
      checkout: "Partenza",
      guests: "Ospiti",
      note: "Conferma le date nel portale qui sotto per vedere prezzi e disponibilità reali.",
    },
    enquiry: {
      title: "Richiedi informazioni",
      sub: "Scrivici: ti risponderemo al più presto con tutti i dettagli.",
      name: "Nome e cognome",
      namePh: "Maria Piras",
      email: "Email",
      emailPh: "maria@email.it",
      message: "Messaggio",
      messagePh: "Ciao, vorrei maggiori informazioni su…",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti risponderemo al più presto.",
      error: "Qualcosa non ha funzionato. Riprova tra poco.",
    },
  },
  en: {
    services: {
      kicker: "For owners",
      heroTitle: "We turn your home into a steady income.",
      heroItalic: "No stress. No guesswork.",
      heroSub: "Premium management with real local presence in Ogliastra. More bookings, fewer problems, total control.",
      heroCta: "Request your free valuation",
      heroBadges: ["Real potential analysis", "No commitment", "Reply within 24 hours"],
      problems: {
        title: "Do any of these sound familiar?",
        items: [
          "No time to manage it all",
          "Wrong prices = money lost",
          "Fear of difficult guests or bad reviews",
          "No real control over management",
        ],
        note: "If even one of these rings true, you're in the right place.",
        strong: "You don't have to do it all alone.",
      },
      about: {
        kicker: "Your local partner in Ogliastra",
        title: "Professional management, human touch",
        p1: "OGStay is a local team that lives Ogliastra every day and treats every property as its own. We are not an automated platform: we are real people on the territory.",
        p2: "We manage a limited number of properties to guarantee quality, control and attention to detail. With over 9 years of experience in Sardinian short-term rentals, we combine local market knowledge, tested marketing strategies and continuous assistance.",
        p3: "The result? Relaxed owners, happy guests and optimised income.",
        stat: "9+",
        statLabel: "Years of short-term rental experience",
      },
      why: {
        kicker: "Why choose OGStay",
        title: "We don't manage houses. We protect investments.",
        sub: "OGStay is the choice for owners who want concrete results, total control and zero stress.",
        items: [
          { title: "Real local presence", text: "We are physically in Ogliastra. We intervene immediately, know the territory and follow every property closely." },
          { title: "Optimised income", text: "Dynamic pricing and tested strategies to increase occupancy and earnings, based on real data." },
          { title: "Full 24/7 management", text: "Guests, emergencies, cleaning and coordination: we take care of everything, always." },
          { title: "Total transparency", text: "Clear access to bookings, income and reports. No surprises." },
          { title: "Human, selective approach", text: "We manage few properties at a time. Quality over quantity. Your home is treated as our own." },
        ],
      },
      tiers: {
        kicker: "Management levels",
        title: "Choose the level of support that suits you",
        sub: "Every solution is designed to maximise your revenue and reduce stress.",
        items: [
          {
            name: "Light Management",
            tagline: "Professional online optimisation",
            desc: "You run the operations. We optimise the performance.",
            long: "For independent, organised owners who want to keep operational control with impeccable, multi-platform, numbers-driven digital management.",
            price: "10% – 15%",
            priceNote: "based on your needs",
            features: [
              "Complete listing makeover (copy, structure, imagery)",
              "Multi-platform optimisation (Airbnb, Booking and main channels)",
              "Dynamic pricing strategy based on real market data",
              "Guest communication support with professional templates",
              "Ongoing operational consulting",
              "Periodic performance analysis with suggestions",
              "Strategic support for revenue and visibility",
            ],
            cta: "Request information",
          },
          {
            name: "Full Management",
            badge: "Main service",
            tagline: "Turnkey solution",
            desc: "We take care of everything. You collect.",
            long: "The complete solution for owners who want concrete results without handling daily operations: from online visibility to guest management and performance control.",
            price: "20% – 25%",
            priceNote: "based on property, area and seasonality",
            features: [
              "Listing management on Airbnb / Booking and main portals",
              "Dynamic pricing strategy based on real data",
              "24/7 guest communication",
              "Professional check-in / check-out",
              "Cleaning and linen coordination",
              "Unexpected events and ordinary maintenance",
              "Initial professional photo shoot",
              "Bureaucratic start-up support",
              "Monthly reports and full performance control",
            ],
            cta: "Request your free valuation",
          },
          {
            name: "Tailored Management",
            tagline: "Built around your case",
            desc: "For properties with specific characteristics or owners who want a tailor-made service.",
            long: "We analyse your case and create a personalised, modular and flexible solution.",
            price: "To be assessed",
            priceNote: "based on your needs",
            features: [
              "Dedicated strategic consulting",
              "Modules activated on request",
              "Operational flexibility",
              "Personalised support",
            ],
            cta: "Let's talk about it",
          },
        ],
      },
      portalAccess: {
        kicker: "Already an OGStay client?",
        title: "Your owner portal",
        sub: "Bookings, calendar, earnings and reports for your property: everything under control, in one place.",
        cta: "Go to the owner portal",
      },
      premium: {
        kicker: "Premium add-on services",
        title: "Make the most of your property",
        cta: "Request a consultation",
        items: [
          { title: "Professional photo shoot", price: "To be assessed", text: "High-quality photos that increase bookings and highlight every detail of your property." },
          { title: "Listing makeover", price: "From €250", text: "Complete optimisation of your listing to maximise conversions and visibility." },
          { title: "Bureaucratic setup", price: "From €300", text: "Complete management of authorisations, registrations and required documentation." },
          { title: "1:1 strategy consultation", price: "€150/hour", text: "A personalised session to optimise your management and pricing strategy." },
        ],
      },
      valuation: {
        kicker: "Free valuation",
        title: "Discover how much your property can earn",
        sub: "Fill in the form and receive a free, no-commitment valuation. We'll tell you how much your property in Ogliastra can yield with professional management.",
        perks: [
          { title: "100% free", text: "No hidden costs, no commitment." },
          { title: "Reply within 24 hours", text: "Fast, professional potential analysis." },
          { title: "Territory experts", text: "We know Ogliastra like no one else." },
        ],
        form: {
          name: "Full name",
          namePh: "Maria Piras",
          email: "Email",
          emailPh: "maria@email.com",
          phone: "Phone / WhatsApp",
          phonePh: "+39 333 000 0000",
          role: "Who are you?",
          roles: ["Owner", "Property manager", "Investor", "Other"],
          type: "Property type",
          types: ["Apartment", "Detached house", "Villa", "B&B / Guesthouse", "Residence", "Other"],
          location: "Where is it located?",
          locationPh: "Tortolì, Arbatax, Baunei…",
          units: "How many units?",
          unitsOpts: ["1", "2–3", "4–10", "10+"],
          guests: "How many guests can it host?",
          guestsOpts: ["2", "4", "6", "8", "10+"],
          status: "Current status",
          statusOpts: [
            "Already active on Airbnb, Booking, etc.",
            "Active but underperforming",
            "Not yet active",
            "Under renovation",
          ],
          platforms: "Platforms you use (if already active)",
          platformsOpts: ["Airbnb", "Booking.com", "Vrbo", "Expedia", "Other"],
          submit: "Request free valuation",
          sending: "Sending…",
          success: "Request sent. We'll reply within 24 hours with a detailed analysis.",
          error: "Something went wrong. Please try again shortly.",
          note: "No cost, no commitment.",
        },
      },
      guida: {
        kicker: "Personalised guest guide",
        value: "Worth €34.90 · Free for a limited time",
        title: "The guide that improves your guests' experience",
        sub: "A premium tool that increases positive reviews and reduces guest requests.",
        points: [
          "Professional ready-to-use template",
          "Customisable for every property",
          "Increases positive reviews",
          "Reduces guest requests",
          "Downloaded by over 200 owners",
        ],
        form: {
          name: "First name",
          namePh: "Maria",
          email: "Email",
          emailPh: "maria@email.com",
          submit: "Get the free guide",
          sending: "Sending…",
          success: "Request received: we'll email you the guide.",
          error: "Something went wrong. Please try again shortly.",
          note: "By requesting the guide you agree to be contacted by OGStay for a free consultation.",
        },
      },
      steps: {
        kicker: "How to start",
        title: "Three simple steps to transform your property",
        items: [
          { title: "Contact", text: "We talk about your property and your needs. No commitment." },
          { title: "Valuation", text: "We analyse your home's potential. Real numbers, no empty promises." },
          { title: "Decision", text: "You receive the personalised proposal. Then you decide, no pressure." },
        ],
      },
      final: {
        title: "No commitment. Real numbers. Then you decide.",
        sub: "Request a free valuation of your property and discover how much you could earn with professional management.",
        ctaPrimary: "Request your free valuation",
        ctaSecondary: "See our properties",
      },
    },
    experiences: {
      kicker: "Experiences",
      heroTitle: "The OGStay experiences",
      heroSub: "Authentic Sardinia, carefully selected. Every experience has been personally chosen by our team to guarantee quality, authenticity and a genuine connection with the territory.",
      badge: "Selected by OGStay",
      from: "From",
      person: "per person",
      priceNote: "Final price to be agreed",
      cta: "Request information",
      items: [
        {
          title: "Boat trip in the Gulf of Orosei",
          text: "Discover the crystal-clear waters and untouched beaches of the Gulf of Orosei on a guided boat tour.",
          location: "Port of Arbatax",
          duration: "Full day (8 hours)",
          schedule: "Every day, May to October",
          price: "€95",
        },
        {
          title: "Winery wine tasting",
          text: "A sensory journey through Sardinia's authentic flavours with a guided local wine tasting.",
          location: "Local winery, Loceri",
          duration: "2.5 hours",
          schedule: "Tuesday, Thursday and Saturday, by reservation",
          price: "€45",
        },
        {
          title: "Trekking in the Gennargentu Park",
          text: "Explore the wild nature and breathtaking views of the Gennargentu with an expert local guide.",
          location: "Park base, Fonni",
          duration: "Half day (5 hours)",
          schedule: "Wednesday and Sunday, on request",
          price: "€60",
        },
      ],
      why: {
        title: "Why choose OGStay",
        sub: "Every experience is carefully selected by our local team to guarantee quality, authenticity and a genuine connection with Sardinia.",
        items: [
          { title: "Local curation", text: "Personally selected by our team, who know every corner of Sardinia." },
          { title: "Authentic guides", text: "Local experts who passionately share the true essence of the territory." },
          { title: "Guaranteed quality", text: "Every experience is tested and approved to guarantee maximum value." },
          { title: "Reliability", text: "Verified partners and consolidated relationships for a worry-free experience." },
        ],
      },
      note: "OGStay is not a travel agency or tour operator. We are local curators who select and recommend the best experiences in Sardinia: bookings and payments are made directly with the experience providers.",
    },
    guide: {
      kicker: "Guides & tips",
      title: "The OGStay journal",
      sub: "Stories, secrets and tips from those who live Ogliastra every day. Discover the territory with new eyes.",
      featured: "Featured",
      readMore: "Read the article",
      newsletter: {
        title: "Stay up to date",
        sub: "Subscribe to the newsletter to receive tips, guides and exclusive offers straight to your inbox.",
        emailPh: "Your email",
        submit: "Subscribe",
        sending: "Sending…",
        success: "Subscription confirmed. Welcome to the OGStay journal.",
        error: "Something went wrong. Please try again shortly.",
      },
    },
    article: {
      back: "Back to the journal",
      related: "Read next",
      ctaTitle: "Experience Ogliastra with OGStay",
      ctaSub: "Selected homes, authentic experiences and a local team always available.",
      cta: "Explore the homes",
    },
    chat: {
      title: "OGStay Concierge",
      sub: "Always by your side",
      welcome: "Hi! I'm the OGStay concierge. Ask me anything about homes, experiences, availability or tips about Ogliastra.",
      placeholder: "Write a message…",
      send: "Send",
      open: "Open the concierge",
      close: "Close the concierge",
      error: "Oops, something went wrong. Please try again shortly.",
      suggestions: ["What homes do you have in Ogliastra?", "How much is the boat trip?", "How does direct booking work?"],
    },
    staysSearch: {
      label: "Your search",
      where: "Destination",
      checkin: "Arrival",
      checkout: "Departure",
      guests: "Guests",
      note: "Confirm the dates in the portal below to see real prices and availability.",
    },
    enquiry: {
      title: "Request information",
      sub: "Write to us: we'll reply as soon as possible with all the details.",
      name: "Full name",
      namePh: "Maria Piras",
      email: "Email",
      emailPh: "maria@email.com",
      message: "Message",
      messagePh: "Hi, I'd like more information about…",
      submit: "Send request",
      sending: "Sending…",
      success: "Request sent. We'll get back to you shortly.",
      error: "Something went wrong. Please try again shortly.",
    },
  },
};
